// src/components/tiles/ProductForJobTile.jsx
import React from 'react';
import { Stack, Typography } from '@mui/material';
import TileShell from './TileShell';
import ScoreBadge from './ScoreBadge';
import InterviewsBadge from './InterviewsBadge';
import ReceiptsList from './ReceiptsList';

import { slugify } from '../../utils/slug';
import { useLocation } from 'react-router-dom';

export default function ProductForJobTile({
  title,
  variant,           // 'win' | 'gap'
  importance,
  satisfaction,
  count,
  sectionTotal,
  receiptsGood = [],
  receiptsBad = []
}) {
  const location = useLocation();
  const pct = sectionTotal ? Math.round((count / sectionTotal) * 100) : 0;

  const metricsRow = (
    <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
      <InterviewsBadge percent={pct} count={count} />
      <ScoreBadge label="Importance" value={importance} metricKey="importance" />
      <ScoreBadge label="Satisfaction" value={satisfaction} metricKey="satisfaction" />
    </div>
  );

  const body = (
    <Stack spacing={1}>
      {!!receiptsGood.length && (
        <>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>The good:</Typography>
          <ReceiptsList receipts={receiptsGood} />
        </>
      )}
      {!!receiptsBad.length && (
        <>
          <Typography variant="body2" sx={{ fontWeight: 600, mt: 1 }}>The bad:</Typography>
          <ReceiptsList receipts={receiptsBad} />
        </>
      )}
    </Stack>
  );

  // Build deep link to Product detail page (preserve current filters via query string)
  const productName = title || '';
  const solutionSlug = slugify(productName);
  const linkTo = solutionSlug ? `/product/${solutionSlug}${location.search || ''}` : null;
  

  return (
    <TileShell
      //typePill={variant === 'win' ? 'Product-win' : 'Product-gap'}
      typePill={'Product for Job'}
      title={title}
      metricsRow={metricsRow}
      body={body}
      linkTo={linkTo}
      href={linkTo}
    />
  );
}
